import {
  APISuperAdminTenant,
  type APISuperAdminTenantResponseType,
  type IAPISuperAdminTenant,
} from "@/core/data_sources/models/APISuperAdminTenant";
import { State } from "@/core/data_sources/store/state";

export type SuperAdminTenantsStateType = {
  list: IAPISuperAdminTenant[];
  count?: number;
};

export class SuperAdminTenantsState extends State<SuperAdminTenantsStateType> {
  constructor() {
    super({ list: [], count: 0 });
  }

  setTenants(tenants: APISuperAdminTenantResponseType[]) {
    this._observable.next({
      list: tenants.map((tenant) => new APISuperAdminTenant(tenant)),
    });
  }

  setCount(count: number) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], count: 0 }),
      count,
    });
  }

  clear(): void {
    this._observable.next({ list: [], count: 0 });
  }
}
